.mat-list-item:hover{background-color:#d3d3d3;cursor:pointer}.notifList{height:45px!important}.notif-overlay-parent{color:#000}.notif-overlay-section{max-width:300px}
/*# sourceMappingURL=/ba/public/notification.component.css.map */
